<script lang="ts">
  import { Welcome } from '@packages/ui'
</script>

<Welcome />
